/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Medical_Training_TermsInputs */

const en_service_type_medical_training_terms = /** @type {(inputs: Service_Type_Medical_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`clinical exercise, exercise after injury, return to sport, back pain, knee, shoulder`)
};

const pl_service_type_medical_training_terms = /** @type {(inputs: Service_Type_Medical_Training_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trening po kontuzji, trening po urazie, powrót do sportu, trening zdrowotny, ból kręgosłupa, ból pleców, kolano, bark`)
};

/**
* | output |
* | --- |
* | "clinical exercise, exercise after injury, return to sport, back pain, knee, shoulder" |
*
* @param {Service_Type_Medical_Training_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_medical_training_terms = /** @type {((inputs?: Service_Type_Medical_Training_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Medical_Training_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_medical_training_terms(inputs)
	return en_service_type_medical_training_terms(inputs)
});